export const DEFAULT_JAVASCRIPT = `// This code will run before the portal loads
// console.log('This code will run before the portal loads');

document.addEventListener('PortalLoaded', () => {
  // This code will run after the portal has loaded
  // console.log('This code will run after the portal has loaded');
});`;
